<div class="col-lg-12">
  <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
    Verify Status Of Mobile No.
  </p>
</div>
<form class="example-form" (ngSubmit)="verifyOtp()" [formGroup]="OTPDetail">

  <div *ngIf="changeMobileNo==true">
    <mat-form-field class="col-lg-6">
      <mat-label>Select Country</mat-label>
      <mat-select formControlName="IsdCode" matTooltip="Select Country" autocomplete="off">
        <mat-form-field>
          <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
        </mat-form-field>
        <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.isdCode">
          <img matSuffix [src]="d?.countryFlag" style="height: 20px;width: 20px;" />
          {{d?.name}}({{d?.isdCodeText}})
        </mat-option>
      </mat-select>
      <mat-error *ngIf="submitted && f.IsdCode.errors">
        Select Country
      </mat-error>
    </mat-form-field>

    <mat-form-field class="col-lg-3">

      <input type="text" matInput placeholder="Phone Number" formControlName="MobileNo" minlength="5" maxlength="13" NumberOnly required />
      <mat-error *ngIf="submitted && f.MobileNo.errors">
        Enter Phone Number
      </mat-error>
    </mat-form-field>
    <button type="button" class="col-lg-3" mat-raised-button color="primary" (click)="changeMobileNoBeforeVerified()">Change Mobile No.</button>

  </div>
  <div *ngIf="changeMobileNo==false">
    <mat-form-field class="col-lg-3">
      <input type="text" matInput placeholder="Phone Number" formControlName="FullMobileNo" readonly />
    </mat-form-field>
    <button type="button" mat-raised-button color="primary" (click)="sendOtp()" disabled="{{IsTimerShow}}">Send OTP</button>

    <a href="javascript: void(0);" class="col-lg-3" style="color:red" (click)="MobileNoBeforeVerified()" *ngIf="!IsTimerShow">Click Here To Change Mobile No. Before Verified</a>


  </div>
  <div *ngIf="IsTimerShow && changeMobileNo==false">
    <span class="col-lg-3">timeLeft to resend OTP:-{{timeLeft}}</span>

    <mat-form-field class="col-lg-3" >
      <input type="text" matInput placeholder="Enter OTP" formControlName="Otp" maxlength="6" NumberOnly required>
      <mat-error *ngIf="submitted && f.Otp.errors">
        Enter OTP
      </mat-error>
    </mat-form-field>

    <button class="col-lg-3" mat-raised-button color="primary">OTP SUBMIT</button>

  </div>
</form>





